// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";

import bg from "@/translation/bg";

// import colors from "vuetify/lib/util/colors";

export default createVuetify({
  // lang: {
  //   locales: { bg },
  //   current: "bg",
  //   locale: "bg",
  //   fallback: "en",
  // },
  locale: {
    locale: "bg",
    fallback: "en",
    messages: { bg },
  },
  // theme: {
  //   defaultTheme: "myLightTheme",
  //   themes: {
  //     myLightTheme: {
  //       colors: {
  //         base: colors.blue.accent1,
  //         anchor: colors.purple.accent2,
  //         primary: colors.purple.base,
  //         "primary--text": colors.blue.accent3,
  //         secondary: colors.lightBlue.darken1,
  //         accent: colors.blue.darken1,
  //         error: colors.red.lighten2,
  //         info: colors.grey.lighten4,
  //         success: colors.green.accent2,
  //       },
  //     },
  //   },
  // },
  components,
  directives,
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
});

// const vuetify = new Vuetify({
// theme: {
//   themes: {
//     light: {
//       base: colors.blue.accent1,
//       anchor: colors.purple.accent2,
//       primary: colors.purple.base,
//       'primary--text': colors.blue.accent1,
//       secondary: colors.lightBlue.darken1,
//       accent: colors.blue.darken1,
//       error: colors.red.lighten2,
//       info: colors.grey.lighten4,
//       success: colors.green.ancient2
//     },
//   },
// },
// });
